import isMobile from "ismobilejs";
export default {
  methods: {
    isMobileAny() {
      return isMobile(window.navigator).any;
    },
  },
};
